<template>
  
  <v-toolbar
    id="core-toolbar"
    flat
    prominent
    :gradient="sidebarOverlayGradiant"
    :style="'position: fixed; background-image:' + $store.state.app.image + ';'"
    class="toolbar-brcorte"
  >
    
    <div v-if="!$store.state.app.drawer && isIOS" class="v-toolbar-title">
      <v-toolbar-title
        class="font-weight-light"
      >
        <v-btn
          
          class="default v-btn--simple"
          dark
          icon
          small
          @click.stop="onClickBtn"
        >
          <v-icon small>mdi-view-list</v-icon>
        </v-btn>
        <span
          v-if="!msgState"
          class="text-limit">{{ isMobile ? title: '' }}</span>
      </v-toolbar-title>
    </div>
    <v-spacer />

    <v-toolbar-items>

      <v-flex
        align-center
        layout
        py-2
      >
        <div>
          <span
            style="color: #fff; padding-left: 15px; padding-right: 15px"
            v-html="msgState"/>
        </div>
        <template v-if="!isMobile">
          <v-layout v-if="user.consultor">

            <v-flex
              xs6
              style="height: 15px; margin-top: -17px;">

              <SelectCliente $style="background-color: #fff; border-radius: 10px; height: 30px; width: 200px;padding-right: 2px; padding-left: 2px"/>
            </v-flex>
          </v-layout>
          <v-flex>
            <v-flex v-if="user.consultor">
              <v-btn
                :title="'Gerenciar Consultoria'"
                icon
                text
                @click="openConsultoria"
              >
                <v-icon color="white">mdi-group</v-icon>
              </v-btn>
            </v-flex>
          </v-flex>
          <v-btn
            :title="strings[idioma].ajuda"
            icon
            text
            dark
            small
            @click="openHelp()">
            <v-icon>mdi-help</v-icon>
          </v-btn>
          <v-flex>
            <v-flex>
              <v-btn
                :title="strings[idioma].suporte"
                icon
                text
                small
                @click="suporte"
              >
                <v-icon color="white">mdi-whatsapp</v-icon>
              </v-btn>
            </v-flex>
          </v-flex>
        </template>
        <v-menu
          :close-on-content-click="false"
          :nudge-width="300"
          v-model="menu"
          open-delay="900"
          bottom
          right
          offset-y
          transition="slide-y-transition"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              text
              small
              v-on="on"
            >
              <v-icon color="white">mdi-account</v-icon>
            </v-btn>
          </template>
          <v-card>

            <v-list two-line>
              <v-list-tile avatar>
                <v-list-tile-avatar>
                  <v-icon>mdi-account</v-icon>
                  <v-icon
                    v-if="user.premium"
                    title="Premium">mdi-star</v-icon>

                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>
                    {{ user.NOME }}
                  </v-list-tile-title>
                  <v-list-tile-sub-title>{{ user.email }}</v-list-tile-sub-title>
                  <template v-if="user.area_universitaria">
                    <small style="font-size: 10px;">Acesso na área universitária e financiada pela UFV!</small>
                  </template>
                  

                  <div
                    v-for="(emp, index) in empresa"
                    :key="index">
                    <v-list-tile-sub-title>{{ emp.nome }}{{ (EMPRESA_TIPOS[emp.acesso]) ? ' - ' + strings[idioma][EMPRESA_TIPOS[emp.acesso]] : '' }} </v-list-tile-sub-title>
                  </div>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>

            <v-divider/>
            <v-card-actions>
              <v-btn
                icon
                text
                small
                @click="toggleDark()"
                :title="'Ativar ou desativar o Dark Mode'"
              >
                <v-icon>mdi-theme-light-dark</v-icon>
              </v-btn>
              <v-btn
                small
                flat
                href="user">{{ strings[idioma].btn_editar }}</v-btn>
              <template v-if="empresaVinculada && !isMobile">
                <v-spacer/>
                <img
                  :title="strings[idioma].licenciado_para + ' ' + empresaVinculada.nome"
                  :src="empresaVinculada.logo"
                  height="30">
              </template>
              <template v-else-if="isMobile">
                <v-spacer/>
                <v-btn
                  :title="strings[idioma].suporte"
                  icon
                  text
                  small
                  @click="suporte"
                >
                  <v-icon>mdi-whatsapp</v-icon>
                </v-btn>
                <v-spacer/>
                <v-btn
                  :title="strings[idioma].ajuda"
                  icon
                  text

                  small
                  @click="openHelp()">
                  <v-icon>mdi-help</v-icon>
                </v-btn>
              </template>
              <v-spacer/>
              <v-btn
                color="error"
                flat
                @click="logout"
              >
                {{ strings[idioma].btn_sair }}
                <v-icon
                  right
                  dark
                >
                  mdi-logout
                </v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
        <v-menu
          :close-on-content-click="false"
          :nudge-width="250"
          :nudge-height="250"
          open-delay="900"
          bottom
          right
          offset-y
          transition="slide-y-transition"
        >
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              text
              small
              v-on="on"
            >
              <v-icon :color="idioma === 0  ? 'green': (idioma === 2) ? 'yellow' : 'red'">mdi-flag</v-icon>
              <template v-if="(idioma === 0)">
                <small
                    v-if="idioma === 0"
                    style="font-weight: bold; padding: 0 2px; background: grey; opacity: 0.9; font-size:9px;">PT-BR</small>
              </template>
              <template v-else-if="(idioma === 1)">
                <small
                    v-if="(idioma === 1)"
                    style="font-weight: bold; padding: 0 2px; background: grey; opacity: 0.9; font-size:9px;">EN</small>
              </template>
              <template v-else-if="(idioma === 2)">
                <small
                    v-if="(idioma === 2)"
                    style="font-weight: bold; padding: 0 2px; background: grey; opacity: 0.9; font-size:9px;">ES</small>
              </template>
            </v-btn>
          </template>
          <v-card max-height="100px" style="padding: 10px;">
            <v-layout wrap flex justify-space-around>
              <v-card :style="idioma === 0 ? 'background-color: blue; padding: 3px; margin: 3px;' : 'padding: 3px;'">
                <v-btn
                  text
                  flat
                  xs4
                  dark
                  small
                  icon
                  
                  title="PT-BR">
                  <v-img
                    src="./img/brasil.png"
                    style="height: 40px!important; width: 50px!important; opacity: 0.7"
                    contain
                    icon
                    @click="setIdioma(0)"
                  >
                    <small
                      v-if="idioma !== 0"
                      style="font-weight: bold; padding: 0 2px; background: grey; opacity: 0.7; font-size:9px; ">PT-BR</small>
                  </v-img>

                </v-btn>
              </v-card>
              <v-card :style="idioma === 1 ? 'background-color: blue; padding: 3px; margin: 3px;' : 'padding: 3px;'">
                <v-btn
                  text
                  dark
                  xs4
                  flat
                  small
                  icon
                  
                  title="EN-US">
                  <v-img
                    src="./img/en.png"
                    style="height: 40px!important; width: 50px!important; opacity: 0.7"
                    contain
                    icon
                    @click="setIdioma(1)"
                  >
                    <small
                      v-if="idioma !== 1"
                      style="font-weight: bold; padding: 0 2px; background: grey; opacity: 0.7; font-size:9px; ">ENGLISH</small>
                  </v-img>
                </v-btn>
              </v-card>
              <v-card :style="idioma === 2 ? 'background-color: blue; padding: 3px; margin: 3px;' : 'padding: 3px;'">
                <v-btn
                  text
                  dark
                  xs4
                  small
                  icon
                  
                  title="ES">
                  <v-img
                    src="./img/es.png"
                    style="height: 40px!important; width: 50px!important; opacity: 0.7"
                    contain
                    icon
                    @click="setIdioma(2)"
                  >
                    <small
                      v-if="idioma !== 2"
                      style="font-weight: bold; padding: 0 2px; background: grey; opacity: 0.7; font-size:9px; ">ESPAÑOL</small>
                  </v-img>
                </v-btn>
              </v-card>
            </v-layout>
          </v-card>
        </v-menu>

      </v-flex>
    </v-toolbar-items>
    <Ajuda ref="ajuda"/>
    <v-dialog
      v-model="dialog"
      :fullscreen="$vuetify.breakpoint.xs"
      persistent
      transition="dialog-bottom-transition">
      <v-card v-if="dialog">
        <v-card-title>
          <v-layout column>
            <span class="headline">Clientes</span>
            <span style="font-weight: 400;">Cadastro de Clientes</span>
            <v-divider/>
          </v-layout>

        </v-card-title>
        <v-card
          :height="heightDialog"
          :max-height="heightDialog"
          style="overflow:auto"
        >
          <v-list>
            <v-list-tile
              class="list-restricoes"
            >
              <v-list-tile-content>
                <v-layout
                  align-center
                  justify-space-around
                  row
                  py-2
                  style="width: 100%"
                >
                  <v-flex xs2>
                    <label for="nome">
                      Nome
                    </label>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      id="nome"
                      v-model="cliente_.nome"/>
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              class="list-restricoes"
            >
              <v-list-tile-content>
                <v-layout
                  align-center
                  justify-space-around
                  row
                  py-2
                  style="width: 100%"
                >
                  <v-flex xs2>
                    <label for="email">
                      E-Mail
                    </label>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      id="email"
                      v-model="cliente_.email"/>
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              class="list-restricoes"
            >
              <v-list-tile-content>
                <v-layout
                  align-center
                  justify-space-around
                  row
                  py-2
                  style="width: 100%"
                >
                  <v-flex xs2>
                    <label for="telefone">
                      Telefone
                    </label>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      id="telefone"
                      v-model="cliente_.telefone"/>
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              class="list-restricoes"
            >
              <v-list-tile-content>
                <v-layout
                  align-center
                  justify-space-around
                  row
                  py-2
                  style="width: 100%"
                >
                  <v-flex xs2>
                    <label for="nome_fazenda">
                      Nome da Fazenda
                    </label>
                  </v-flex>
                  <v-flex>
                    <v-text-field
                      id="nome_fazenda"
                      v-model="cliente_.nome_fazenda"/>
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile
              class="list-restricoes"
            >
              <v-list-tile-content>
                <v-layout
                  align-center
                  justify-space-around
                  row
                  py-2
                  style="width: 100%"
                >
                  <v-flex xs2>
                    <label for="obs">
                      Obs
                    </label>
                  </v-flex>
                  <v-flex>
                    <v-textarea
                      id="obs"
                      v-model="cliente_.obs"/>
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>

          </v-list>
        </v-card>
        <v-card-actions>
          <v-spacer/>
          <v-btn

            :title="strings[idioma].salvar_nutrientes"
            color="success"
            @click="save()"
          >
            <v-icon
              dark>mdi-content-save</v-icon>
          </v-btn>

          <v-btn
            :title="strings[idioma].fechar"
            color="error"
            @click="descartar()"
          >
            <v-icon
              dark>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogConsultoria"
      :fullscreen="$vuetify.breakpoint.xs"
      persistent
      transition="dialog-bottom-transition">
      <v-card v-if="dialogConsultoria">
        <v-card-title>
          <v-layout column>
            <span class="headline">Área do Consultor</span>
            <span
              v-if="user.consultor"
              style="font-weight: 400;">Válido até: {{ moment(user.consultoria.data_fim).format(strings[idioma].formato_datas_sem_hora) }} - Máx. Clientes: {{ user.consultoria.max_clientes }}</span>
            <v-divider/>
          </v-layout>

        </v-card-title>
        <v-card
          v-if="user.consultor"
          :height="heightDialog"
          :max-height="heightDialog"
          style="overflow:auto"
        >
          <v-card-title>
            <v-layout column>
              <span class="headline">Clientes ({{ clientes.length }} / {{ user.consultoria.max_clientes }})</span>

              <v-divider/>
            </v-layout>

          </v-card-title>
          <v-list>
            <v-list-tile
              v-for="cl in clientes"
              :key="cl.id"
              class="list-restricoes"
            >

              <v-list-tile-content>
                <v-layout
                  align-center
                  justify-space-around
                  row
                  py-2
                  style="width: 100%"
                >
                  <v-flex xs10>
                    <label :for="cl.id">
                      <span style="font-weight: bold">{{ cl.nome }} ({{ cl.nome_fazenda }}) - {{ cl.email }} // {{ cl.telefone }}</span>
                    </label>
                  </v-flex>
                  <v-flex>
                    <v-btn
                      :id="cl.id"
                      @click="editarCliente(cl)">{{ strings[idioma].editar }}</v-btn>
                    <v-btn @click="removerCliente(cl)">X</v-btn>
                  </v-flex>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>

          </v-list>
        </v-card>
        <v-card-actions>
          <v-spacer/>

          <v-btn
            :title="strings[idioma].fechar"
            color="error"
            @click="dialogConsultoria = false"
          >
            <v-icon
              dark>mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-toolbar>
</template>

<script>

import {
  mapMutations,
  mapState
} from 'vuex'
import axios from 'axios'
import AxiosOffline from 'axios-offline'
import Vue from 'vue'
import { EMPRESA_TIPOS } from '../../utils/types'
import Ajuda from '../../views/components/Ajuda'
import txt from 'raw-loader'
import moment from 'moment'
import SelectCliente from '../../views/consultor/components/SelectCliente.vue'
import AlertHelper from '../../plugins/alert'
export default {
  props: {
    hover: {
      type: Boolean,
      default: false
    },
  },
  components: {
    Ajuda,
    SelectCliente
  },
  data: () => ({
    empresaParceiraInfo: null,
    empresaVinculada: null,
    menu: false,
    responsiveInput: false,
    title: null,
    EMPRESA_TIPOS: EMPRESA_TIPOS,
    clientes: [],
    cliente: -2,
    cliente_: {
      nome: '',
      email: '',
      telefone: '',
      obs: '',
      id_consultor: null
    },
    dialog: false,
    dialogConsultoria: false,
    
  }),

  computed: {
    ...mapState('app', ['consultoria', 'menus', 'idioma', 'strings', 'user', 'empresa', 'responsive', 'curr_version', 'msgState', 'exibeLoja', 'isIOS']),
    heightCard () {
      return String(this.$vuetify.breakpoint.height - 289) + 'px'
    },
    heightDialog () {
      return this.$vuetify.breakpoint.xs ? String(this.$vuetify.breakpoint.height - 150) + 'px' : String(this.$vuetify.breakpoint.height - 240) + 'px'
    },
    heightOverflow () {
      return 'max-height: ' + String(this.$vuetify.breakpoint.height - 120) + 'px; overflow: auto;'
    },
    ClientesLista () {
      let lista = [{ id: -1, nome: '➕ Cliente' }, { id: -2, nome: '- Uso Pessoal' }]
      lista.push(...this.clientes)
      return lista
    },
    isMobile () {
      return (this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.md)
    },
    ehParceiro () {
      return this.user && this.user.empresaParceira && this.user.empresaParceira.id > 0
    },
    sidebarOverlayGradiant () {
      return `${this.$store.state.app.sidebarBackgroundFooterColor}, ${this.$store.state.app.sidebarBackgroundFooterColor}`
    },
    inputValue: {
        get () {
          if (this.$route.path === '/dashboard' && this.$vuetify.breakpoint.width > 991) return true
          return this.$store.state.app.drawer
        },
        set (val) {
          this.setDrawer(val)
        }
    }
  },

  watch: {
    '$route' (val) {
      this.title = val.name[this.idioma]
      document.title = this.title
    },
    'cliente' (val) {
      if (val === -2) localStorage.removeItem('cliente')
      else if (val === -1) return null
      else {
        let cliente = localStorage.getItem('cliente')
        cliente = this.clientes.filter(c => c.id === val)[0]
        localStorage.setItem('cliente', JSON.stringify(cliente))
      }
    }
  },
  async created () {
    if (this.user.plano && this.user.plano.id_empresa !== null) {
      await this.getInfoEmpresa(this.user.plano.id_empresa)
    }
    window.Offline.options = { checks: { image: { url: 'https://www.google.com/images/srpr/logo11w.png' }, active: 'image' } }
    document.onkeydown = null
    document.removeEventListener('keydown', this.keysEvent)
    document.addEventListener('keydown', this.keysEvent)
    if (localStorage.getItem('MOBILE_ACCESS')) return
    if (localStorage.getItem('version') && localStorage.getItem('version') !== this.curr_version) {
      this.logout()
    }
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer', 'toggleDark']),
    async getInfoEmpresa (idEmpresa) {
      try {
        let res = await this.$getInfoEmpresa(idEmpresa)
        this.empresaParceiraInfo = res
      } catch (error) {
        this.empresaParceiraInfo = null
        console.log(error)
      }
    },
    suporte () {
      if (this.empresaParceiraInfo && this.empresaParceiraInfo.suporte_link) {
        if (!window.open(this.empresaParceiraInfo.suporte_link, '_blank')) {
          window.location.href = this.empresaParceiraInfo.suporte_link
        }
      } else {
        let title = this.strings[this.idioma].suporte
        let msg = this.strings[this.idioma].suporte_corpo
        this.$store.commit('openOKModal', { title, msg })
      }
    },
    moment (...args) {
      return moment(...args)
    },
    openConsultoria () {
      window.open('/consultor?ref=clientes')
      // this.get().then(_ => {
      //   this.dialogConsultoria = true
      // })
    },
    editarCliente (cliente) {
      this.cliente_ = cliente
      this.dialog = true
    },
    async removerCliente (cliente) {
      const podeRemover = (await AlertHelper.confirm(this.strings[this.idioma].msg_remove)).isConfirmed
      if (podeRemover) {
        this.axios.post('consultoria/clientes/delete', { ...cliente }).then(_ => {
          alert('Removido com sucesso!!!')
          this.get()
        }).catch(_ => {
          alert('Erro ao remover!!!')
        })
      }
    },
    descartar () {
      this.cliente_ = {
        nome: '',
        email: '',
        telefone: '',
        obs: '',
        id_consultor: this.user.consultoria.id
      }
      let cliente = JSON.parse(localStorage.getItem('cliente'))
      this.cliente = cliente ? cliente.id : -2
      this.dialog = false
      this.get()
    },
    get () {
      return this.axios.post('consultoria/clientes', { id: this.user.consultoria.id }).then(r => {
        this.clientes = r.data.data
        let cliente = JSON.parse(localStorage.getItem('cliente'))
        if (cliente && cliente !== null) this.cliente = cliente.id
      })
    },
    save () {
      this.axios.post('consultoria/clientes/create', { ...this.cliente_ }).then(r => {
        alert('Salvo com sucesso!!!')
        this.cliente_.id_consultor = this.user.consultoria.id
        
      }).catch(r => {
        alert('Houve um problema ao cadastrar o cliente. Verifique se não excedeu o número máximo de clientes permitidos!')
      }).then(_ => {
        let cliente = JSON.parse(localStorage.getItem('cliente'))
        this.cliente = cliente ? cliente.id : -2
        this.dialog = false
        this.get()
      })
    },
    changeCliente () {
      if (this.cliente !== -1) {
        setTimeout(r => {
          window.location.reload()
        }, 100)
      } else {
        this.cliente_ = {
          nome: '',
          email: '',
          telefone: '',
          obs: '',
          id_consultor: this.user.consultoria.id
        }
        this.dialog = true
      }
    },
    keysEvent (evt) {
      evt = evt || window.event
      let local = localStorage.getItem('local')
      if (evt.ctrlKey && evt.keyCode === 45) {
        alert('Versão - ' + this.curr_version + ' - Build: ' + txt + ' - ' + ((local) ? 'Rodando com banco de dados local.' : 'Rodando na nuvem.'))
      }
      const atalhos = {
        'f': '/formulacao-dieta',
        'p': '/predicao-desempenho',
        's': '/formulacao-suplemento',
        'x': '/calcula-exigencias',
        'u': '/user',
        'd': '/dashboard',
        't': '/tabela-resumida',
        'i': '/calcular-racao',
        'a': '/enviar-alimento',
      }
      if (evt.ctrlKey && evt.altKey) {
        const rota = atalhos[evt.key.toLowerCase()]
        if (rota) {
          console.log('Atalho: Ctrl + Alt + ' + evt.key.toLowerCase() + ' - ' + rota);
          this.$router.push(rota)
        }
      }
    },
    openHelp () {
      return this.$refs.ajuda.openHelp()
    },
    getLogo (idEmpresa) {
      if (this.empresaVinculada === null) return null
      return this.axios.post('empresa/getLogo', { id: idEmpresa }).then(res => {
        this.empresaVinculada.logo = res.data.data
        return this.empresaVinculada.logo
      })
    },
    logout () {
      const desloga = () => {
        this.axios.defaults.headers.common['Authorization'] = null
        this.$limpaLocalStorage()
        localStorage.removeItem('user')
        localStorage.removeItem('user-token')
        localStorage.removeItem('lastUpdate')
        localStorage.removeItem('alimentos')
        localStorage.removeItem('empresa')
        localStorage.removeItem('tipos')
        localStorage.removeItem('usa_dieta')
        localStorage.removeItem('usa_predicao')
        localStorage.removeItem('usa_tabela')
        localStorage.removeItem('acesso')
        sessionStorage.removeItem('empresaAdm')
        this.$store.commit('resetStates')
        window.location.replace('/login')
      }
      let token = localStorage.getItem('user-token')
      return this.axios.post('auth/logout', { token: token }).finally(() => {
        desloga()
      }).catch(() => {});
    },
    onClickBtn () {
      this.setDrawer(!this.$store.state.app.drawer)
    },
    onClick () {
      //
    },
    async setIdioma (idioma) {
      this.$store.commit('setIdioma', idioma)
      this.title = this.$route.name[idioma]
      this.$vuetify.lang.current = idioma === 1 ? 'en' : idioma === 0 ? 'pt' : 'es'
      await this.axios.post('setIdioma', { id: this.user.id, idioma: idioma })
    }
  }
}
</script>

<style>
  .text-limit {
    max-width: 100px!important;
    min-width: 20px!important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: small;
    text-transform: capitalize;
  }
  #core-toolbar a {
    text-decoration: none;
  }
  #core-toolbar:hover{
    opacity: 0.9;
  }
  #core-toolbar:not(:hover){
    opacity: 0.8;
  }
</style>
